import { useEffect, useState } from "react";
import type { FC } from "react";

import { SelfEvaluationOption } from "components";

import type { SelfEvaluationFragment } from "api/generated";

import { getFirebaseAssetURL } from "utils/getFirebaseAssetURL";

interface Props {
  selectIndex: number;
  selfEvaluationData: SelfEvaluationFragment | null | undefined;
  score: number | null;
  handleEvaluationSelect: (index: number, points: number) => void;
}

const SelfEvaluationOptionSelection: FC<Props> = ({
  selectIndex,
  selfEvaluationData,
  score,
  handleEvaluationSelect,
}) => {
  if (selfEvaluationData === null || selfEvaluationData === undefined) return null;

  const [imageUrls, setImageUrls] = useState<string[]>(new Array(selfEvaluationData.options.length).fill(""));

  useEffect(() => {
    selfEvaluationData.options.forEach((option, index) => {
      if (typeof option.image === "string") {
        getFirebaseAssetURL(option.image)
          .then(url => {
            if (url === undefined) return;
            setImageUrls(urls => {
              const copy = [...urls];
              copy[index] = url;
              return copy;
            });
          })
          .catch(() => {});
      }
    });
  }, []);

  if (selfEvaluationData.options.length === 0) {
    return (
      <div>
        <p style={{ textAlign: "center" }}>
          <h1 style={{ color: "red" }}>Nejsou nastaveny volby pro sebehodnocení!</h1>
        </p>
      </div>
    );
  }

  return (
    <>
      {selfEvaluationData.options.map((option, optionIndex) => {
        const { scoreReal } = option;
        if (typeof scoreReal !== "number") return null;

        return (
          <SelfEvaluationOption
            key={`${selectIndex}-${optionIndex}`}
            score={score}
            scoreReal={scoreReal}
            optionText={option.text}
            selectIndex={selectIndex}
            optionIndex={optionIndex}
            imagePath={Array.isArray(imageUrls) ? imageUrls?.[optionIndex] : undefined}
            handleEvaluationSelect={handleEvaluationSelect}
          />
        );
      })}
    </>
  );
};

export default SelfEvaluationOptionSelection;
